import { render, staticRenderFns } from "./paying.vue?vue&type=template&id=6a10c8c2&scoped=true&"
import script from "./paying.vue?vue&type=script&lang=js&"
export * from "./paying.vue?vue&type=script&lang=js&"
import style0 from "./paying.vue?vue&type=style&index=0&id=6a10c8c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a10c8c2",
  null
  
)

export default component.exports